import common from './methods/common'
import dataGrid from './methods/data-grid'
import multiselect from './methods/multiselect'
import dataGridParser from './methods/data-grid'
import loadingQueue from './methods/loading-queue'
import corePagesGridSync from './methods/core-pages-grid-sync'

const utils = {
  ...common,
  ...dataGrid,
  ...multiselect,
  dataGridParser,
  loadingQueue,
  corePagesGridSync,
}

export default utils
